<template>
  <div class="post">
    <div class="post-container container">
      <post-header
        :title="title"
        :image="image"
        :credits="credits"
        :subtitle="subtitle" />

      <post-content :content="content" />
    </div>
  </div>
</template>

<script>
import PostHeader from '@/components/Post/Header.vue';
import PostContent from '@/components/Post/Content.vue';

export default {
  computed: {
    title() {
      return this.$route.meta.data.title;
    },
    image() {
      return this.$route.meta.data.image;
    },
    credits() {
      return this.$route.meta.data.credits;
    },
    subtitle() {
      return this.$route.meta.data.subtitle;
    },
    content() {
      return this.$route.meta.data.content;
    },
  },
  components: {
    'post-header': PostHeader,
    'post-content': PostContent,
  },
};
</script>

<style lang="scss">
.post {
  position: relative;

  width: 100%;

  padding-top: rem-calc(40);

  @media #{$medium-up} {
    padding-top: rem-calc(70);
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    max-height: rem-calc(180);

    z-index: -1;
    background-color: $minsk;

    @media #{$medium-up} {
      max-height: rem-calc(450);
    }
  }
}
</style>
